module.exports = __webpack_public_path__ + "static/media/document.6e897647.png";